import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import routerActions from 'app/routerActions';
import * as selectors from '../../app/selectors';
import { KBPopover, KBPopoverTop, KBError, KBSuccess } from 'components';

var MembershipsBox = class extends React.Component {componentDidMount()
  {}componentDidUpdate(prevProps) {}render()
  {
    return <div className="kb-out-box clear-fix">{this.props.children}</div>;
  }};


export default MembershipsBox;
